import { FETCH, FETCH_CANCEL, FETCH_START, FETCH_SUCCESS, FETCH_ERROR, RESET_STATE } from './constants';
let exports;

/**
 * Take a list of parameters and their names & transform it into an object
 * @example
 *  // returns {
 *    propertyId: 'e44c45d45cd4',
 *    startDate: '2018-01-02',
 *    endDate: '2018-01-06',
 *    count: 42,
 *  }
 *  mapParametersToObject(
 *    ['propertyId', 'startDate', 'endDate', 'count'],
 *    ['e44c45d45cd4', '2018-01-02', '2018-01-06', 42],
 *  );
 * @param  {String[]} argsMapping - list of expected parameters, in order
 * @param  {*[]}      args - list of given parameters
 * @return {Object}   an object with the parameter value mapped to its name
 */
const mapParametersToObject = (argsMapping, args) =>
    argsMapping.reduce(
        (params, argName, index) => ({
            ...params,
            [argName]: args[index],
        }),
        {},
    );

const makeFetch =
    (key, argsMapping) =>
    (...args) => ({
        type: FETCH,
        key,
        params: exports.mapParametersToObject(argsMapping, args),
    });

const makeFetchStarted = (key) => (params) => ({
    type: FETCH_START,
    key,
    params,
});

const makeFetchCancelled = (key) => () => ({
    type: FETCH_CANCEL,
    key,
});

const makeFetchSucceeded = (key) => (data) => ({
    type: FETCH_SUCCESS,
    key,
    data,
});

const makeFetchFailed = (key) => (error) => ({
    type: FETCH_ERROR,
    key,
    error,
});

const makeResetState = (key) => () => ({
    type: RESET_STATE,
    key,
});

/**
 * Generate 5 actions to initiate & handle data fetching
 * @param  {String} key
 * @param  {String[]} argsMapping - list of expected parameters for the fetch action, in order
 * @return {Object} an object with 5 actions: fetch, fetchStarted, fetchCancelled,
 *                  fetchSucceeded, fetchFailed
 */
const createActions = (key, argsMapping) => ({
    fetch: exports.makeFetch(key, argsMapping),
    fetchStarted: exports.makeFetchStarted(key),
    fetchCancelled: exports.makeFetchCancelled(key),
    fetchSucceeded: exports.makeFetchSucceeded(key),
    fetchFailed: exports.makeFetchFailed(key),
    resetState: exports.makeResetState(key),
});

export default exports = {
    mapParametersToObject,
    makeFetch,
    makeFetchStarted,
    makeFetchCancelled,
    makeFetchSucceeded,
    makeFetchFailed,
    makeResetState,
};

export { createActions };
